import { NgModule, ModuleWithProviders } from '@angular/core';
import { LocalStorageService } from './local.storage.service';
import { ILocalStorageServiceConfig } from './local.service.config';

@NgModule({
  providers: [
    LocalStorageService
  ]
})
export class LocalStorageModule {
  static withConfig(userConfig: ILocalStorageServiceConfig = {}): ModuleWithProviders {
    return {
      ngModule: LocalStorageModule,
      providers: [
        { provide: 'LOCAL_STORAGE_SERVICE_CONFIG', useValue: userConfig }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/common/local.storage.service/local.storage.module.ts